document.addEventListener("DOMContentLoaded", () => {

const openBtn = document.querySelector(".zaeth-header__menu");
const closeBtn = document.querySelector(".zaeth-menu-close");
const menu = document.querySelector(".zaeth-fullscreen-menu");

if (!openBtn || !closeBtn || !menu) return;

openBtn.addEventListener("click", () => {
    menu.classList.add("active");
});

closeBtn.addEventListener("click", () => {
    menu.classList.remove("active");
});

document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
        menu.classList.remove("active");
    }
});

});